import { Stack, Theme } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { ColoredIcon } from '../ColoredIconAndChip';
import DownloadLink from './DownloadLink';
import { TDocumentUrl } from './types';

/**
 * We don't implement PDF thumbnail for now.
 */
export default function PdfThumbnail({ url, filename }: Readonly<TDocumentUrl>) {
  return (
    <Stack gap={tokens.spacingBase}>
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          backgroundColor: (theme: Theme) => theme.palette.divider,
          borderRadius: tokens.borderRadiusSm,
          aspectRatio: '25/16',
        }}
      >
        <ColoredIcon iconName="pdfRounded" color="disabled" />
      </Stack>
      <DownloadLink filename={filename} url={url} />
    </Stack>
  );
}
